

export class LanguageOutputWithoutStatus implements ILanguageOutputWithoutStatus {
    /** The auto-generated id of the language master */
    language_id!: number;
    /** The language name with 255 character limit */
    language_name!: string;

    constructor(data?: ILanguageOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language_id = _data["language_id"];
            this.language_name = _data["language_name"];
        }
    }

    static fromJS(data: any): LanguageOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language_id"] = this.language_id;
        data["language_name"] = this.language_name;
        return data; 
    }
}

export interface ILanguageOutputWithoutStatus {
    /** The auto-generated id of the language master */
    language_id: number;
    /** The language name with 255 character limit */
    language_name: string;
}

